import classes from "./TreeSelect.module.css";

export default function TreeNode({ node, checkedIds, onToggleCheck }) {
  const truncateWithTooltip = () => {
    const name = `${node.first_name}  ${node.last_name}`;
    if (!name || name.length <= 20)
      return <span className={classes.user_name}>{name}</span>;
    return (
      <span title={name} className={classes.user_name}>
        {name.slice(0, 20)}...
      </span>
    );
  };
  return (
    <li key={node.user_id}>
      <div className={classes["tree-row"]} style={{ paddingLeft: 12 }}>
        <input
          type="checkbox"
          className={classes["tree-checkbox"]}
          checked={[...checkedIds].some((n) => n === node.user_id)}
          onChange={() => onToggleCheck(node)}
          aria-label={`Select ${node.first_name} ${node.last_name}`}
        />
        {truncateWithTooltip()}
      </div>
    </li>
  );
}
